import axios from 'axios';
import { getAuthToken, setAuthToken } from './authUtils';
import config from '../config';

const referrerApiService = axios.create({
  baseURL: config.apiUrl, 
});

referrerApiService.interceptors.request.use(
  (config) => {
    const authToken = getAuthToken('referrer');
    if (authToken) {
      config.headers.Authorization = `Bearer ${authToken}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

referrerApiService.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      localStorage.removeItem('rtoken');
      window.location.href = '/referrer';
      console.error('Authentication error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default referrerApiService;
